import React, { useEffect, useState } from 'react';
import './index.less';
import '@jd/jmtd-charts/dist/themes/default.css'; // 默认皮肤
import '../yx.css';
import '../yx-pro.css';
import '../yx-extra.css';
import apis from '../../apis';
import {
  Button,
  CircleProgress,
  CardHeader,
  CardSection,
  Tag,
  Popover,
  DropdownCheckboxOption,
  DropdownList,
  Icon,
  Select,
  Message,
  Space,
  Label,
  Tooltip
} from '@jd/jmtd';

import { formatDate } from '@jd/jmtd-tools/es/date';
import { format } from '@jd/jmtd-tools/es/number';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import 'swiper/css';

export default function (props) {
  const [selIdList, setSelIdList] = useState([]);
  const [planList, setPlanList] = useState([]);
  const [summaryList, setSummaryList] = useState([]);
  const [loadList, setLoadList] = useState(0);

  // const swiper = useSwiper();

  //请求mvp 销售计划列表
  useEffect(()=>{
    apis.queryMarketingPlanList({status: 1, pageSize: 20, planFilter: 1}).then((res) => {
      const {
        ret,
        data: { list = [] },
      } = res;
      if (ret === '0') {
        // 转化数据就是 name->label code->value
        const dataStr = JSON.stringify(list)
          .replace(/name/g, 'label')
          .replace(/code/g, 'value');
        const formatList = JSON.parse(dataStr);
        // let idList = window.localStorage.getItem(`__${props.erp}__marketingPlanIndexes__`)
        // if (idList) idList = JSON.parse(idList)
        //
        // idList = idList || formatList.map(item=>item.value).slice(0,3);
        // const idList = formatList.map(item=>item.value).slice(0,3);
        const idList = formatList.filter(item=>item.orders < 4).map(item=>item.value);
        console.log({formatList})
        setPlanList(formatList)
        setSelIdList(idList)
      }
    });
  },[loadList])

  //请求mvp 销售计划详情
  useEffect(()=>{
    if(props.reload != -1 ){
      setLoadList(prevState => ({
        prevState: prevState++
      }))
    }
  },[ props.reload])

  //请求mvp 销售计划详情
  useEffect(()=>{
    if(props.reload != -1 || planList?.length > 0){
      apis.queryMarketingPlanSummary({marketingPlanCodes: [], status: 1}).then((res) => {
        const {
          ret,
          data: { list = [] },
        } = res;
        if (ret === '0') {
          setSummaryList(list)
        }
      });
    }
  },[selIdList, props.reload])

  const styleTag = {
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.3)',
    backgroundColor: '#F4F4F5',
    height: '22px',
    lineHeight: '22px',
    padding: '0 8px',
    bordered: 'none'
  };
  const CustomRender = ({ value: selected, update, open, setOpen, change }, { data: options }) => {
    const checkedSet = new Set(selected);
    return {
      // onClose: change,
      onClose:()=>{},
      selector: (
        <div
          clsTag={'h|keycount|yx_center_hzcp_1678258944439|1'}
          className='custom-render-con'
          onClick={() => {
            setOpen(!open);
          }}
          endIcon={<Icon className='jmti-angle-down' />}
          style={{ cursor: 'pointer' }}
        >
          选择置顶展示的计划，已选{selected.length}项    <Icon className='jmti-angle-down' />
        </div>
      ),
      dropdown: (
        <DropdownList width={269}>
          <div>
            {options.map(({ label, value, status }) => {
              const checked = checkedSet.has(value);
              return (
                <DropdownCheckboxOption
                  key={value}
                  checked={checked}
                  onChange={() =>
                  {
                    if(!checked && selected.length >=3){
                      Message.danger({ content: '最多选择3项' })
                      return
                    }
                    update({
                      value: checked
                        ? selected.filter(i => i !== value)
                        : selected.concat(value)
                    })
                  }
                  }
                >
                  <div className='tag-dropdown-option'>
                    <Label value={value}>{label}</Label>
                    {status == 1 && <Tag size='small' color='green'>进行中</Tag>}
                    {status == 2 && <Tag size='small' style={styleTag}>未开始</Tag>}
                    {status == 3 && <Tag size='small' style={styleTag}>已结束</Tag>}
                    {status == 4 && <Tag size='small' style={styleTag}>草稿</Tag>}
                  </div>
                </DropdownCheckboxOption>
              );
            })}
          </div>
          <div style={{textAlign: 'right', margin:'5px'}}>
            <Button
              data-event-name='confirm'
              size='mini'
              semantic='primary'
              onClick={() => {
                setOpen(false);
                change(selected);
              }}
            >
              确认
            </Button>
          </div>
        </DropdownList>
      )
    };
  };

  const emptyLength = summaryList?.length > 0 ? 3-summaryList?.length : 3;
  const emptyList = [0,1,2].slice(0, emptyLength)
  const emptyHtml = emptyList.map(()=>{
    return(
      <div className="sales-tab-col-item sales-tab-col-item-empty">
        <Button
          className='sales-tab-col-btn'
          startIcon={<Icon className='jmti-plus-circle' />}
          semantic='primary'
          onClick={()=>{props.toSalePlan({create: true})}}
          clsTag={'h|keycount|yx_center_hzcp_1678258944439|4'}
        >去新建
        </Button>
      </div>
    )
  })
  function handleClick(e, code){
    e.preventDefault(); e.stopPropagation();
    props.toSalePlan({code, editable: true})
  }

  function handlePlanListChange(val){
    if(val?.length === 0){
      Message.danger({ content: '最少选择1项' });
      return
    }

    apis.saveMarketingPlan({marketingPlanCodes: val}).then((res) => {
      const {
        ret,
        data: { list = [] },
      } = res;
      if (ret === '0') {
        setLoadList(prevState => ({
          prevState: prevState++
        }))
      }
    });

    setSelIdList(val)
  }
  const itemHtml = summaryList?.length > 3 ? summaryList.map(({name, code, status, startTime, endTime, total, complete, completeRate, totalDay, currentDay })=>{
    return (
      <SwiperSlide>
        <div className="sales-tab-col-item" clsTag={'h|keycount|yx_center_hzcp_1678258944439|2'} onClick={()=>{props.toSalePlan({code, editable: false})}}>
          <div className='sales-tab-col-con'>
            <div className='sales-tab-col-title'>{name}</div>
            {status == 1 && <Tag size='small' color='green'>进行中</Tag>}
            {status == 2 && <Tag size='small' style={styleTag}>未开始</Tag>}
            {status == 3 && <Tag size='small' style={styleTag}>已结束</Tag>}
            {status == 4 && <Tag size='small' style={styleTag}>草稿</Tag>}
            <Popover placement='bottomRight' popover={
              <div className='sales-tab-popover-content' onClick={(e)=>{handleClick(e, code)}}>
                {/*<div className='sales-tab-popover-content-btn' clsTag={'h|keycount|yx_center_hzcp_1678258944439|2'} onClick={()=>{props.toSalePlan({code, editable: false})}}>查看</div>*/}
                <div className='sales-tab-popover-content-btn' clsTag={'h|keycount|yx_center_hzcp_1678258944439|3'}>编辑</div>
              </div>}>
              <div className='sales-tab-col-dot' onClick={(e) => { e.preventDefault(); e.stopPropagation();}}>...</div>
            </Popover >
          </div>
          <div className='sales-tab-col-sub-title'>{formatDate(new Date(startTime), 'MM/DD')}—{formatDate(new Date(endTime), 'MM/DD')}</div>
          <div className='sales-tab-col-progress'>
            <div className='sales-tab-col-progress-left'>
              <div className='process-container-big'>
                <CircleProgress
                  key={code}
                  bgColors={['rgba(0,122,255,0.1)']}
                  pgColors={['#007AFF']}
                  percent={[complete / total * 100]}
                  size={76}
                  animate
                  text={null}
                  strokeWidth={7}
                  textStyle={{display:'none'}}
                />
              </div>
              <div className='process-container-small'>
                <CircleProgress
                  key={code}
                  bgColors={['rgba(54,207,201,0.1)']}
                  pgColors={['#36CFC9']}
                  percent={[currentDay/totalDay * 100]}
                  size={50}
                  animate
                  text={null}
                  strokeWidth={7}
                  textStyle={{display:'none'}}
                />
              </div>
            </div>
            <div className='sales-tab-col-progress-right'>
              <div className='sales-tab-col-progress-item'>
                <div className='sales-tab-col-progress-title-con'>
                  <div className='sales-tab-col-progress-title-dot'></div>
                  <div className='sales-tab-col-progress-title'>成交金额进度</div>
                </div>
                <div className='sales-tab-col-progress-number'>{Math.ceil((complete / total * 100))}<span>%</span></div>
                <div className='sales-tab-col-progress-sub-number'>{format(complete, 'currency_¥')} / {format(total, 'currency_¥')}</div>
              </div>
              <div className='sales-tab-col-progress-item'>
                <div className='sales-tab-col-progress-title-con'>
                  <div className='sales-tab-col-progress-title-dot'></div>
                  <div className='sales-tab-col-progress-title'>时间进度</div>
                </div>
                <div className='sales-tab-col-progress-number'>{(currentDay/totalDay * 100).toFixed()}<span>%</span></div>
                <div className='sales-tab-col-progress-sub-number'>{currentDay}天 / {totalDay}天</div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
    )

  }) : summaryList?.length > 0 ? summaryList.map(({name, code, status, startTime, endTime, total, complete, completeRate, totalDay, currentDay })=>{
    return (
      <div className="sales-tab-col-item" clsTag={'h|keycount|yx_center_hzcp_1678258944439|2'} onClick={()=>{props.toSalePlan({code, editable: false})}}>
        <div className='sales-tab-col-con'>
          <div className='sales-tab-col-title'>{name}</div>
          {status == 1 && <Tag size='small' color='green'>进行中</Tag>}
          {status == 2 && <Tag size='small' style={styleTag}>未开始</Tag>}
          {status == 3 && <Tag size='small' style={styleTag}>已结束</Tag>}
          {status == 4 && <Tag size='small' style={styleTag}>草稿</Tag>}
          <Popover placement='bottomRight' popover={
            <div className='sales-tab-popover-content' onClick={(e)=>{handleClick(e, code)}}>
              {/*<div className='sales-tab-popover-content-btn' clsTag={'h|keycount|yx_center_hzcp_1678258944439|2'} onClick={()=>{props.toSalePlan({code, editable: false})}}>查看</div>*/}
              <div className='sales-tab-popover-content-btn' clsTag={'h|keycount|yx_center_hzcp_1678258944439|3'}>编辑</div>
            </div>}>
            <div className='sales-tab-col-dot' onClick={(e) => { e.preventDefault(); e.stopPropagation();}}>...</div>
          </Popover >
        </div>
        <div className='sales-tab-col-sub-title'>{formatDate(new Date(startTime), 'MM/DD')}—{formatDate(new Date(endTime), 'MM/DD')}</div>
        <div className='sales-tab-col-progress'>
          <div className='sales-tab-col-progress-left'>
            <div className='process-container-big'>
              <CircleProgress
                key={code}
                bgColors={['rgba(0,122,255,0.1)']}
                pgColors={['#007AFF']}
                percent={[complete / total * 100]}
                size={76}
                animate
                text={null}
                strokeWidth={7}
                textStyle={{display:'none'}}
              />
            </div>
            <div className='process-container-small'>
              <CircleProgress
                key={code}
                bgColors={['rgba(54,207,201,0.1)']}
                pgColors={['#36CFC9']}
                percent={[currentDay/totalDay * 100]}
                size={50}
                animate
                text={null}
                strokeWidth={7}
                textStyle={{display:'none'}}
              />
            </div>
          </div>
          <div className='sales-tab-col-progress-right'>
            <div className='sales-tab-col-progress-item'>
              <div className='sales-tab-col-progress-title-con'>
                <div className='sales-tab-col-progress-title-dot'></div>
                <div className='sales-tab-col-progress-title'>成交金额进度</div>
              </div>
              <div className='sales-tab-col-progress-number'>{Math.ceil((complete / total * 100))}<span>%</span></div>
              <div className='sales-tab-col-progress-sub-number'>{format(complete, 'currency_¥')} / {format(total, 'currency_¥')}</div>
            </div>
            <div className='sales-tab-col-progress-item'>
              <div className='sales-tab-col-progress-title-con'>
                <div className='sales-tab-col-progress-title-dot'></div>
                <div className='sales-tab-col-progress-title'>时间进度</div>
              </div>
              <div className='sales-tab-col-progress-number'>{(currentDay/totalDay * 100).toFixed()}<span>%</span></div>
              <div className='sales-tab-col-progress-sub-number'>{currentDay}天 / {totalDay}天</div>
            </div>
          </div>
        </div>
      </div>
    )

  }) : ''
  return (
    <div className="sales-tab-card-bg">
      <CardHeader className="sales-tab-title" right={<Button semantic='primary' outline clsTag={'h|keycount|yx_center_hzcp_1678258944439|5'}   onClick={()=>{props.toSalePlan()}}>管理计划</Button>}>
        <Space>
          <span>
            商品销售计划
            <Tooltip title={<span>
              可支持按照品类、品牌、店铺、商品等维度精细化设置和管理销售计划目标。<br></br>
            1、计划时间跨度：支持选择连续92天；<br></br>
            2、成交金额进度：按照成交金额口径，从计划开始时间到昨日达成的累计成交金额/目标成交金额；<br></br>
            3、时间进度：从计划开始日期到昨日的累计天数/计划总天数。
            </span>}>
              <Icon className='jmti-question-circle' ></Icon>
            </Tooltip>
          </span>
          {
            planList?.length > 2 &&
            <Select
              clsTag={'h|keycount|yx_center_hzcp_1678258944439|1'}
              render={CustomRender}
              data={planList}
              value={selIdList}
              onChange={(val)=>(handlePlanListChange(val))}
              width={280}
              showLength
              maxLength={3}
              messageRender={({ overflow }) => {
                if (overflow) {
                  return {
                    type: 'danger',
                    children: '超过最大数量'
                  };
                }
                return null;
              }}
            />
          }

        </Space>
      </CardHeader>
      {
        planList?.length === 0 ?
          <CardSection className="sales-tab-section no-data">
          <div className="sales-tab-col-common">
            <div className='sales-tab-col-title'>1 创建销售计划</div>
            <p className='sales-tab-col-text'>设置销售计划名称、计划时间</p>
            <Button
              className='sales-tab-col-btn'
              startIcon={<Icon className='jmti-plus-circle' />}
              semantic='primary'
              onClick={()=>{props.toSalePlan({create: true})}}
              clsTag={'h|keycount|yx_center_hzcp_1678258944439|4'}
            >去创建
            </Button>
            <div className='sales-tab-col-1'></div>
          </div>
          <div className="sales-tab-col-common">
            <div className='sales-tab-col-title'>2 添加销售计划</div>
            <p className='sales-tab-col-text'>支持以商品、品牌、品类、店铺等维度添加销售计划、设置计划目标</p>
            <div className='sales-tab-col-2'></div>
          </div>
          <div className="sales-tab-col-common">
            <div className='sales-tab-col-title'>3 拆解销售计划</div>
            <p className='sales-tab-col-text'>支持以计划的维度，对计划目标进行时间段拆分，帮助你更加精细化设置和管理销售目标</p>
            <div className='sales-tab-col-3'></div>
          </div>
        </CardSection> :
          <CardSection className="sales-tab-section has-data">
            {
              summaryList?.length > 3 ?
                <Swiper
                  key={props.reload}
                  modules={[Navigation]}
                  cssMode={true}
                  navigation={true}
                  pagination={true}
                  mousewheel={false}
                  keyboard={false}
                  spaceBetween={16}
                  slidesPerView={3}
                  slidesPerGroup={3}
                  onSlideChange={() => console.log('slide change')}
                  onSwiper={(swiper) => console.log(swiper)}
                >
                  {itemHtml}
                </Swiper> :
                <>
                  {itemHtml}
                  {emptyHtml}
                </>
            }


          </CardSection>
      }
    </div>
  );
}
